import React, { ReactElement } from 'react';
import { ContainerLayout } from 'layouts';
import { TranslationContext } from '@ds/react-utils';
import { WarningIcon } from 'components/shared';

const PageNotFoundPage = (): ReactElement => {
    const translate = React.useContext(TranslationContext);

    return (
        <ContainerLayout>
            <ContainerLayout.Header>
                <WarningIcon dataQa='verify-page-not-found-warning-icon' />
                <ContainerLayout.Header.Title titleDataQa="verify-page-not-found-title" title={translate("That page doesn't exist")} />
            </ContainerLayout.Header>
        </ContainerLayout>
    );
};

export default PageNotFoundPage;
